module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("krORu"))).then(() => parcelRequire('37nVf'));